import { KYMW0A00Model } from '../kymw0a00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 組合員の声管理情報取得のサービス
 *
 * @export GetMembersVoiceDataService
 * @class GetMembersVoiceDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMembersVoiceDataService extends PlessJsonResponderSub<any> {
  private model: KYMW0A00Model = null;
  private selectReceiptNum: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMembersVoiceDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ReceiptNum: this.selectReceiptNum
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model KYMW0A00Model
   * @memberof GetMembersVoiceDataService
   */
  execute(model: KYMW0A00Model, selectReceiptNum: string, successFunc: Function): void {
    this.model = model;
    this.selectReceiptNum = selectReceiptNum;
    this.successFunc = successFunc;
    this.send('getMembersVoiceData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMembersVoiceDataService
   */
  success(data: any): void {
    // サーバからの結果を元に、組合員の声管理データを更新する
    this.model.getMembersVoiceData(data);
    this.successFunc();
  }
}
